import styled from "styled-components";
import { PrimaryButton } from "./PrimaryButton";

export interface ButtonDialogProps {
	color: string;
}
export const CustomButtonDialog = styled(PrimaryButton)<ButtonDialogProps>`
	background-color: ${(props) => props.color} !important;
	border-color: ${(props) => props.color} !important;
	&.p-button:hover {
		background-color: ${(props) => props.color};
		border-color: ${(props) => props.color};
	}
`;
